import { render, staticRenderFns } from "./main-section.vue?vue&type=template&id=5e1fa2f3&scoped=true"
import script from "./main-section.vue?vue&type=script&lang=js"
export * from "./main-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1fa2f3",
  null
  
)

export default component.exports